import _ from 'lodash';
import { GET_ALBUM, DELETE_USEROWNFEED, ADD_ALBUM } from '../Actions/actionTypes';

const initial = {
    album:[]
};
export default (state=initial,action)=>{
    switch(action.type){
      case 'BEFORE_ADD':
            state.album.ImagesList.unshift([{ImageUrl:"",OriginalImageUrl:"",feedDetail:"",isImage:""}]);
            return _.cloneDeep({...state});
      case ADD_ALBUM:
            if(state.album.ImagesList) {
                // state.album.ImagesList[0] = {ImageUrl:action.payload.url,OriginalImageUrl:action.payload.url,feedDetail:action.payload.data.results.FeedDetail,isImage:action.payload.img}
                state.album.ImagesList.unshift({ImageUrl:action.payload.url,OriginalImageUrl:action.payload.url,feedDetail:action.payload.data.results.FeedDetail,isImage:action.payload.img});
            }
            else {
                state.album.ImagesList = [{ImageUrl:action.payload.url,OriginalImageUrl:action.payload.url,feedDetail:action.payload.data.results.FeedDetail,isImage:action.payload.img}];
            }
            state.album.TotalRecords = state.album.TotalRecords + 1;
            state.albumLength = state.albumLength + 1;
            return _.cloneDeep({...state});
        case GET_ALBUM:
            if(state.albumLength) {
                if(state.albumLength < action.payload.TotalRecords) {
                    state.album.ImagesList = state.album.ImagesList.concat(action.payload.ImagesList);
                }
            }
            else {
                state.album = action.payload;
            }
            return _.cloneDeep({...state,albumLength:state.album.ImagesList ?state.album.ImagesList.length : 0});
        case DELETE_USEROWNFEED:
            let deleteIndex = _.findIndex(state.album.ImagesList,(image)=> image.feedDetail.FeedId === action.payload.FeedId);
            if(deleteIndex !== -1) {
                state.album.ImagesList.splice(deleteIndex,1);
                state.album.TotalRecords = state.album.TotalRecords - 1;
                state.albumLength = state.albumLength - 1;
            }
            return _.cloneDeep({...state});
        default:
            return state;
    }
}